export default "__VITE_ASSET__2LBrjyNN__"